// document.addEventListener('DOMContentLoaded', function() {
//   //filter tab switch functionality 
//   const filterLinks = document.querySelectorAll('.filter-list .filter-list__item:not(.size)');
//   const filterContents = document.querySelectorAll('.filter-content:not(.size)');
//   filterLinks.forEach(link => {
//       link.addEventListener('click', function() {
//           filterLinks.forEach(l => l.classList.remove('active'));
//           this.classList.add('active');
//           const filterId = this.getAttribute('id');
//           filterContents.forEach(content => {
//               content.style.display = 'none';
//           });
//           const activeContent = document.querySelector(`.filter-content[data-filter-id="${filterId}"]`);
//           if (activeContent) {
//               activeContent.style.display = 'block';
//           }
//           if(filterId === 'limitededition'){
//             document.querySelector('.filter-content[data-filter-id="limitededition"] li').click();
//           }
//           else {
//             if(document.querySelector('.filter-content[data-filter-id="limitededition"] li').classList.contains('active'))
//             document.querySelector('.filter-content[data-filter-id="limitededition"] li').click();
//           }
//       });
//   });

// });

// //add selected filters

// function generateFilterList(filters, productCount) {
//     let html = '';
//     const productLabel = productCount === 1 ? 'Watch' : 'Watches';
//     html = `<div class="product-count">${productCount} ${productLabel}</div>`;
    
//     // Loop through each filter type in the activeFilters object
//     for (const filterType in filters) {
//         if (filters.hasOwnProperty(filterType)) {
//             // Loop through each filter name in the current filter type
//             filters[filterType].forEach(filterName => {
//                 html += `
//                     <remove-filter-item class="remove-filter__item" data-remove-title="${filterName}">
//                         <span>${filterType.charAt(0).toUpperCase() + filterType.slice(1)}: <em>${filterName.replace(/-/g, ' ')}</em></span>
//                         <span>
//                           <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
//                               <path d="M0.192 10L4.44 4.672L0.816 0.0399995H2.928L5.496 3.424L8.112 0.0399995H10.224L6.576 4.696L10.704 10H8.592L5.448 5.944L2.304 10H0.192Z" fill="#424242"></path>
//                           </svg>
//                         </span>
//                     </remove-filter-item>
//                 `;
//             });
//         }
//     }
//     return html;
// }

// //remove the selected elements
// class RemoveFilterItem extends HTMLElement {
//     constructor() {
//         super();
//     }
//     connectedCallback() {
//         this.addEventListener('click', () => {
//             const removeTitle = this.getAttribute('data-remove-title');
//             const correspondingColorItem = document.querySelector(`.color-filter__list-item:not(.slick-cloned)[data-title="${removeTitle}"]`);
//             if(correspondingColorItem) {
//               correspondingColorItem.click();
//             }
//             this.remove();
//         });
//     }
// }

// customElements.define('remove-filter-item', RemoveFilterItem);

// $(document).ready(function() {
//   $('.color-filter__list-item').on('click', function() {
//     //Filter Menu Changes
//     $(this).toggleClass('active');
    
//     let activeFilters = {};
//     let activeFiltersList = [];
//     let totalProductCount = 0;
    
//     document.querySelectorAll('[data-filter-id]').forEach(element => {
//         const title = element.getAttribute('data-filter-id').trim();
//         if (!activeFilters[title]) {
//             activeFilters[title] = [];
//         }
//     });
//     $('.filter-content').each(function(event){
//       let currentElement= event.target;
//         if($(this).find('.color-filter__list-item.active').length){
//           let filtertype = $(this).attr('data-filter-id').trim();
//           $(this).find('.color-filter__list-item.active').each(function() {
//               let filterItem = $(this).attr('data-title');
//               activeFilters[filtertype].push(filterItem);
//               activeFiltersList.push(filterItem);
//           });
//         }
//     });
    
//     //Collection product cards hide and show based on filter
//     $('.vintage-collection__item').each(function() {
//       let productModel = $(this).attr('data-model') || '';
//       let variantColor = $(this).attr('data-options') || '';
//       let variantType = $(this).attr('data-type') || '';
//       let variantSize = $(this).attr('data-variant') || '';

//       function matchesFilter(activeFilterArray, productAttribute) {
//         return (productAttribute.length > 0 && 
//                 (activeFilterArray.length === 0 || 
//                  activeFilterArray.some(filter => productAttribute.indexOf(filter) > -1)));
//       }

//       console.log(activeFilters);
//       // Check all filters
//       let containsModel = (activeFilters.year.length > 0) ? matchesFilter(activeFilters.year, productModel) : true;
//       let containsColor = (activeFilters.color.length > 0) ? matchesFilter(activeFilters.color, variantColor): true;
//       let containsType = (activeFilters.limitededition.length > 0) ? matchesFilter(activeFilters.limitededition, variantType): true;
//       let containsSize = (activeFilters.size.length > 0) ? matchesFilter(activeFilters.size, variantSize): true;      
              
//       // AND logic to check for all the qualifiers
//       if (containsModel && containsColor && containsType && containsSize) {
//           $(this).show().addClass('active');
//           totalProductCount+=1;
//       } else {
//           $(this).hide().removeClass('active');
//       }
//     });

//     document.querySelector(".coll-filter-selected-list-part").innerHTML = generateFilterList(activeFilters, totalProductCount);

//     //show the zero products count
//     if(totalProductCount == 0){
//       document.querySelector('.product-count-zero').classList.remove('hide');
//       document.querySelector('.product-list-bar').classList.add('hide');
//     }
//     else {
//       document.querySelector('.product-list-bar').classList.remove('hide');
//       document.querySelector('.product-count-zero').classList.add('hide');
//     }
    
//     if(activeFiltersList.length <= 0) {
//       $('.vintage-collection__item').show().addClass('active');
//     }
//   });
  
//   //slider
//   $('.color-filter-slider').slick({
//     infinite: true,
//     slidesToShow: 7,
//     slidesToScroll: 7,
//     touchMove: true,
//     arrows: true,
//     prevArrow: `<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg class="color-slider__prev" width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 1L1 13.5L13.5 26" stroke="black" stroke-opacity="0.75"></path></svg></button>`,
//     nextArrow: `<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg class="color-slider__next" width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13.5 13.5L1 26" stroke="black" stroke-opacity="0.75"></path></svg></button>`,
//     responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: true,
//         slidesToShow: 4,
//         slidesToScroll: 4,
//         touchMove: true,
//       }
//     }
//   ]
//   });
// });


// // sort-functionality
// document.addEventListener('DOMContentLoaded', function() {
//     const sortByList = document.getElementById('sortBy');
//     const productList = document.querySelector('.vintage-collection__grid');

//     sortByList.addEventListener('click', function(event) {
//         if (event.target.tagName === 'LI') {
//             const sortBy = event.target.getAttribute('value');
//             sortProducts(sortBy);
//         }
//     });

//     function sortProducts(sortBy) {
//         const products = Array.from(productList.children);

//         switch (sortBy) {
//             case 'best-selling':
//                 products.sort((a, b) => {
//                     const aBestseller = a.getAttribute('data-bestseller') === 'true' ? 1 : 0;
//                     const bBestseller = b.getAttribute('data-bestseller') === 'true' ? 1 : 0;
//                     return bBestseller - aBestseller; // Sort by bestseller first
//                 });
//                 break;

//             case 'title-ascending':
//                 products.sort((a, b) => {
//                     const titleA = a.getAttribute('data-product-title').toLowerCase();
//                     const titleB = b.getAttribute('data-product-title').toLowerCase();
//                     return titleA.localeCompare(titleB);
//                 });
//                 break;

//             case 'title-descending':
//                 products.sort((a, b) => {
//                     const titleA = a.getAttribute('data-product-title').toLowerCase();
//                     const titleB = b.getAttribute('data-product-title').toLowerCase();
//                     return titleB.localeCompare(titleA);
//                 });
//                 break;

//             case 'price-ascending':
//                 products.sort((a, b) => {
//                     const priceA = parseFloat(a.getAttribute('data-product-price'));
//                     const priceB = parseFloat(b.getAttribute('data-product-price'));
//                     return priceA - priceB;
//                 });
//                 break;

//             case 'price-descending':
//                 products.sort((a, b) => {
//                     const priceA = parseFloat(a.getAttribute('data-product-price'));
//                     const priceB = parseFloat(b.getAttribute('data-product-price'));
//                     return priceB - priceA;
//                 });
//                 break;
//         }

//         // Clear the product list and append sorted products
//         productList.innerHTML = '';
//         products.forEach(product => productList.appendChild(product));
//     }
// });

// //sort hide and show functionality
// document.addEventListener('DOMContentLoaded', function() {
//     const sortFilter = document.querySelector('.sort-filter');
//     const sortList = document.getElementById('sortBy');
//     const sortByText = document.getElementById('sortByText');

//     sortFilter.addEventListener('click', function() {
//         sortList.classList.toggle('show'); 
//     });

//     sortList.addEventListener('click', function(event) {
//       let currentElement = event.target;
//       const activeElement = document.querySelector('.sort__list-item.active');
//         if (currentElement.classList.contains('sort__list-item')) {
//             if(activeElement) activeElement.classList.remove('active');
//             const selectedText = currentElement.textContent;
//             sortByText.textContent = selectedText;
//             currentElement.classList.add('active');
//             sortList.classList.remove('show');
//         }
//     });

//     document.addEventListener('click', function(event) {
//         if (!sortFilter.contains(event.target)) {
//             sortList.classList.remove('show');
//         }
//     });
// });

// //apped the filter in dofference place in mobile
// const sortComponents = document.querySelector('.sort-components');
// const filterWrapper = document.querySelector('.filter-wrapper');
// function moveSortComponents() {
//     if (window.innerWidth <= 768) {
//         if (filterWrapper && sortComponents) {
//             filterWrapper.parentNode.insertBefore(sortComponents, filterWrapper.nextSibling);
//         }
//     }
// }

// moveSortComponents();
// window.addEventListener('resize', moveSortComponents);

// // Select the div to remove
// let sizeFilter = document.querySelector('.filter-content.size');
// let sizeFilterParent = document.querySelector('.size__filter');
// if (sizeFilter && sizeFilterParent) {
//     sizeFilterParent.appendChild(sizeFilter);
// }

// const sizeFilterContainer = document.querySelector(".size__filter");
// const sizeFilterItem = document.querySelector(".filter-list__item.size");
// const sizeFilterDropdown = document.querySelector(".filter-content.size");


// sizeFilterContainer.addEventListener("click", function (event) {
//     event.stopPropagation(); 
//     sizeFilterItem.classList.toggle("active");
//     sizeFilterDropdown.classList.toggle("active");
// });

// document.addEventListener("click", function (event) {
//     if (!sizeFilterContainer.contains(event.target) && !sizeFilterItem.contains(event.target)) {
//         sizeFilterItem.classList.remove("active");
//         sizeFilterDropdown.classList.remove("active");
//     }
// });










  document.addEventListener('DOMContentLoaded', function() {
  // -------------------------
  // Filter tab switch functionality
  // -------------------------
  const filterLinks = document.querySelectorAll('.filter-list .filter-list__item:not(.size)');
  const filterContents = document.querySelectorAll('.filter-content:not(.size)');

  filterLinks.forEach(link => {
      link.addEventListener('click', function() {
          filterLinks.forEach(l => l.classList.remove('active'));
          this.classList.add('active');
          const filterId = this.getAttribute('id');

          filterContents.forEach(content => content.style.display = 'none');
          const activeContent = document.querySelector(`.filter-content[data-filter-id="${filterId}"]`);
          if (activeContent) activeContent.style.display = 'block';

          // Special handling for limited edition
          if (filterId === 'limitededition') {
            const firstItem = document.querySelector('.filter-content[data-filter-id="limitededition"] li');
            if(firstItem) firstItem.click();
          } else {
            const limitedItem = document.querySelector('.filter-content[data-filter-id="limitededition"] li');
            if(limitedItem && limitedItem.classList.contains('active')) limitedItem.click();
          }
      });
  });

  // -------------------------
  // Custom element for removing selected filter
  // -------------------------
  class RemoveFilterItem extends HTMLElement {
      constructor() {
          super();
      }
      connectedCallback() {
          this.addEventListener('click', () => {
              const removeTitle = this.getAttribute('data-remove-title');
              const correspondingColorItem = document.querySelector(`.color-filter__list-item:not(.slick-cloned)[data-title="${removeTitle}"]`);
              if(correspondingColorItem) correspondingColorItem.click();
              this.remove();
          });
      }
  }
  customElements.define('remove-filter-item', RemoveFilterItem);

  // -------------------------
  // Generate filter list HTML
  // -------------------------
  function generateFilterList(filters, productCount) {
      const productLabel = productCount === 1 ? 'Watch' : 'Watches';
      let html = `<div class="product-count">${productCount} ${productLabel}</div>`;
        if(productCount == 0){
            document.querySelector(".product-count-zero").style.display = "block";
        }
      for (const filterType in filters) {
          if (filters.hasOwnProperty(filterType)) {
              filters[filterType].forEach(filterName => {
                  html += `
                      <remove-filter-item class="remove-filter__item" data-remove-title="${filterName}">
                          <span>${filterType.charAt(0).toUpperCase() + filterType.slice(1)}: <em>${filterName.replace(/-/g, ' ')}</em></span>
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                                <path d="M0.192 10L4.44 4.672L0.816 0.0399995H2.928L5.496 3.424L8.112 0.0399995H10.224L6.576 4.696L10.704 10H8.592L5.448 5.944L2.304 10H0.192Z" fill="#424242"></path>
                            </svg>
                          </span>
                      </remove-filter-item>
                  `;
              });
          }
      }
      return html;
  }

  // -------------------------
  // Color filter click functionality
  // -------------------------
  const colorFilterItems = document.querySelectorAll('.color-filter__list-item');
  colorFilterItems.forEach(item => {
      item.addEventListener('click', () => {
          item.classList.toggle('active');

          let activeFilters = {};
          let activeFiltersList = [];
          let totalProductCount = 0;

          document.querySelectorAll('[data-filter-id]').forEach(el => {
              const title = el.getAttribute('data-filter-id').trim();
              if (!activeFilters[title]) activeFilters[title] = [];
          });

          document.querySelectorAll('.filter-content').forEach(filterContent => {
              const filterType = filterContent.getAttribute('data-filter-id').trim();
              const activeItems = filterContent.querySelectorAll('.color-filter__list-item.active');
              activeItems.forEach(activeItem => {
                  const filterName = activeItem.getAttribute('data-title');
                  activeFilters[filterType].push(filterName);
                  activeFiltersList.push(filterName);
              });
          });

          // Show/hide products based on active filters
          const products = document.querySelectorAll('.vintage-collection__item');
          products.forEach(product => {
              const productModel = product.getAttribute('data-model') || '';
              const variantColor = product.getAttribute('data-options') || '';
              const variantType = product.getAttribute('data-type') || '';
              const variantSize = product.getAttribute('data-variant') || '';

              function matchesFilter(activeFilterArray, productAttribute) {
                  return (productAttribute.length > 0 &&
                          (activeFilterArray.length === 0 ||
                           activeFilterArray.some(filter => productAttribute.indexOf(filter) > -1)));
              }

              const containsModel = activeFilters.year && activeFilters.year.length > 0 ? matchesFilter(activeFilters.year, productModel) : true;
              const containsColor = activeFilters.color && activeFilters.color.length > 0 ? matchesFilter(activeFilters.color, variantColor) : true;
              const containsType = activeFilters.limitededition && activeFilters.limitededition.length > 0 ? matchesFilter(activeFilters.limitededition, variantType) : true;
              const containsSize = activeFilters.size && activeFilters.size.length > 0 ? matchesFilter(activeFilters.size, variantSize) : true;

              if (containsModel && containsColor && containsType && containsSize) {
                  product.style.display = '';
                  product.classList.add('active');
                  totalProductCount += 1;
              } else {
                  product.style.display = 'none';
                  product.classList.remove('active');
              }
          });

          // Update selected filters HTML
          const filterListContainer = document.querySelector(".coll-filter-selected-list-part");
          if(filterListContainer) filterListContainer.innerHTML = generateFilterList(activeFilters, totalProductCount);

          // Show/hide zero product count
          const zeroCount = document.querySelector('.product-count-zero');
          const productBar = document.querySelector('.product-list-bar');
          if (totalProductCount === 0) {
              if(zeroCount) zeroCount.classList.remove('hide');
              if(productBar) productBar.classList.add('hide');
          } else {
              if(productBar) productBar.classList.remove('hide');
              if(zeroCount) zeroCount.classList.add('hide');
          }

          // Reset all products if no filters
          if(activeFiltersList.length <= 0) {
              products.forEach(p => { p.style.display = ''; p.classList.add('active'); });
          }
      });
  });

  // -------------------------
  // Slick slider replacement with basic JS carousel (optional)
  // -------------------------
  // For simplicity, you may keep Slick if required; otherwise, implement a lightweight vanilla JS slider here.
});

// -------------------------
// Sorting functionality
// -------------------------
document.addEventListener('DOMContentLoaded', function() {
    const sortByList = document.getElementById('sortBy');
    const productList = document.querySelector('.vintage-collection__grid');

    function sortProducts(sortBy) {
        const products = Array.from(productList.children);

        switch(sortBy) {
            case 'best-selling':
                products.sort((a,b) => (b.getAttribute('data-bestseller') === 'true'?1:0) - (a.getAttribute('data-bestseller') === 'true'?1:0));
                break;
            case 'title-ascending':
                products.sort((a,b) => a.getAttribute('data-product-title').toLowerCase().localeCompare(b.getAttribute('data-product-title').toLowerCase()));
                break;
            case 'title-descending':
                products.sort((a,b) => b.getAttribute('data-product-title').toLowerCase().localeCompare(a.getAttribute('data-product-title').toLowerCase()));
                break;
            case 'price-ascending':
                products.sort((a,b) => parseFloat(a.getAttribute('data-product-price')) - parseFloat(b.getAttribute('data-product-price')));
                break;
            case 'price-descending':
                products.sort((a,b) => parseFloat(b.getAttribute('data-product-price')) - parseFloat(a.getAttribute('data-product-price')));
                break;
        }

        productList.innerHTML = '';
        products.forEach(p => productList.appendChild(p));
    }

    if(sortByList){
      sortByList.addEventListener('click', function(e) {
          if(e.target.tagName === 'LI') sortProducts(e.target.getAttribute('value'));
      });
    }
});

// -------------------------
// Sort dropdown show/hide
// -------------------------
document.addEventListener('DOMContentLoaded', function() {
    const sortFilter = document.querySelector('.sort-filter');
    const sortList = document.getElementById('sortBy');
    const sortByText = document.getElementById('sortByText');

    if(sortFilter && sortList && sortByText){
      sortFilter.addEventListener('click', () => sortList.classList.toggle('show'));

      sortList.addEventListener('click', function(event) {
          const currentElement = event.target;
          const activeElement = sortList.querySelector('.sort__list-item.active');
          if(currentElement.classList.contains('sort__list-item')){
              if(activeElement) activeElement.classList.remove('active');
              sortByText.textContent = currentElement.textContent;
              currentElement.classList.add('active');
              sortList.classList.remove('show');
          }
      });

      document.addEventListener('click', function(event){
          if(!sortFilter.contains(event.target)) sortList.classList.remove('show');
      });
    }
});

// -------------------------
// Move sort components on mobile
// -------------------------
function moveSortComponents() {
    const sortComponents = document.querySelector('.sort-components');
    const filterWrapper = document.querySelector('.filter-wrapper');
    if(window.innerWidth <= 768 && sortComponents && filterWrapper){
        filterWrapper.parentNode.insertBefore(sortComponents, filterWrapper.nextSibling);
    }
}
moveSortComponents();
window.addEventListener('resize', moveSortComponents);

// -------------------------
// Size filter dropdown
// -------------------------
const sizeFilterContainer = document.querySelector(".size__filter");
const sizeFilterItem = document.querySelector(".filter-list__item.size");
const sizeFilterDropdown = document.querySelector(".filter-content.size");

if(sizeFilterContainer && sizeFilterItem && sizeFilterDropdown){
    sizeFilterContainer.addEventListener("click", function(event){
        event.stopPropagation();
        sizeFilterItem.classList.toggle("active");
        sizeFilterDropdown.classList.toggle("active");
    });

    document.addEventListener("click", function(event){
        if(!sizeFilterContainer.contains(event.target) && !sizeFilterItem.contains(event.target)){
            sizeFilterItem.classList.remove("active");
            sizeFilterDropdown.classList.remove("active");
        }
    });
}


function initColorFilterSwiper() {
  const sliderEl = document.querySelector('.filter-content.swiper');
  
  if (!sliderEl) {
    // Retry in 200ms if the container is not yet in DOM
    setTimeout(initColorFilterSwiper, 200);
    return;
  }

  const slides = sliderEl.querySelectorAll('.color-filter__list-item');
  if (!slides.length) {
    // Retry in 200ms if slides are not yet added
    setTimeout(initColorFilterSwiper, 200);
    return;
  }

  // Prevent multiple Swiper instances
  if (sliderEl.swiper) return;

  // Add navigation buttons if not already present
  if (!sliderEl.querySelector('.swiper-button-next')) {
    const nextBtn = document.createElement('div');
    nextBtn.className = 'swiper-button-next';
    sliderEl.appendChild(nextBtn);
  }
  if (!sliderEl.querySelector('.swiper-button-prev')) {
    const prevBtn = document.createElement('div');
    prevBtn.className = 'swiper-button-prev';
    sliderEl.appendChild(prevBtn);
  }

  // Initialize Swiper
  new Swiper(sliderEl, {
    slidesPerView: 7,
    slidesPerGroup: 7,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: { slidesPerView: 4, slidesPerGroup: 4 },
      768: { slidesPerView: 7, slidesPerGroup: 7 },
    },
  });
}

// Start checking after DOM is ready
document.addEventListener('DOMContentLoaded', initColorFilterSwiper);